<!--
 * @Author: hanmiao
 * @Date: 2022-01-12 16:22:17
 * @description:
-->
<template>
  <div class="decoration-list">
    <SearchComponent ref="search" :routeName="$route.name" :condition="condition" @updateData="_updateData" />
    <TableComponent :routeName="$route.name" :pagination="pagination" :tableData="tableData" @updateData="_updateData" />
  </div>
</template>
<script>
import SearchComponent from '../SearchComponent'
import TableComponent from '../TableComponent'
import updateData from 'mixins/updateData'
export default {
  name: 'DecorationList',
  components: {
    SearchComponent,
    TableComponent
  },
  mixins: [updateData],
  props: {
    decorationType: {
      type: String
    }
  },
  data() {
    this.keyMap = {
      procedure_list: {
        name: 'tableData',
        add_time: 'time',
        app_name: 'appletsName',
        applet_id: 'appletsId',
        editing_time: 'editTime',
        merchant_name: 'merchantName',
        renovation_status: 'status',
        decoration_method: 'decorationMethod',
        renovation_id: 'id',
        led_id: 'ledId',
        renovation_name: 'decorationPageName'
      }
    }
    return {
      condition: {},
      tableData: [],
      pagination: {}
    }
  },
  created() {
    this._getDecorationList({
      curpage: 1,
      renovation_type: this.decorationType
    })
  },
  methods: {
    /**
     * 获取列表
     * @param params
     * @private
     */
    _getDecorationList(params) {
      this.api.getDecorationData(params).then(res => {
        this.utils.setCommonCode(res, this)
      })
    }
  }
}
</script>
